import React, { useState, createRef, useEffect } from 'react';
import { TransitionGroup, CSSTransition } from 'react-transition-group';
import { Box } from '@miro-site/core';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Container = styled(Box).attrs({
  $mt: 28
}).withConfig({
  displayName: "AnimatedUsps__Container",
  componentId: "sc-188buhp-0"
})(["position:relative;"]);
var AnimatedItem = styled.section.withConfig({
  displayName: "AnimatedUsps__AnimatedItem",
  componentId: "sc-188buhp-1"
})(["font-size:14px;color:#050038;padding:0;margin:0;position:absolute;top:0;left:0;&.item-enter{transform:translate(0,14px);opacity:0;}&.item-enter-active{opacity:1;transform:translate(0,0);transition:all 500ms ease-out;}&.item-exit{opacity:1;}&.item-exit-active{opacity:0;transition:all 200ms;}"]);
var IconWrapper = styled.span.withConfig({
  displayName: "AnimatedUsps__IconWrapper",
  componentId: "sc-188buhp-2"
})(["margin-right:8px;svg{vertical-align:middle;}"]);

var AnimatedList = function AnimatedList(_ref) {
  var items = _ref.items;

  var _useState = useState(0),
      index = _useState[0],
      setIndex = _useState[1];

  useEffect(function () {
    var interval = setInterval(function () {
      setIndex(function (prevIndex) {
        return (prevIndex + 1) % items.length;
      });
    }, 3000);
    return function () {
      clearInterval(interval);
    };
  }, []);
  var _items$index = items[index],
      id = _items$index.id,
      nodeRef = _items$index.nodeRef,
      _items$index$usp = _items$index.usp,
      icon = _items$index$usp.icon,
      text = _items$index$usp.text;
  return /*#__PURE__*/_jsx(Container, {
    children: /*#__PURE__*/_jsx(TransitionGroup, {
      children: /*#__PURE__*/_jsx(CSSTransition, {
        nodeRef: nodeRef,
        timeout: 500,
        classNames: "item",
        children: /*#__PURE__*/_jsxs(AnimatedItem, {
          ref: nodeRef,
          children: [/*#__PURE__*/_jsx(IconWrapper, {
            children: icon
          }), /*#__PURE__*/_jsx("span", {
            children: text
          })]
        })
      }, id)
    })
  });
};

export default function AnimatedUsps(props) {
  var items = props.usps.map(function (usp, index) {
    return {
      id: "usps-".concat(index),
      usp: usp,
      nodeRef: /*#__PURE__*/createRef()
    };
  });
  return /*#__PURE__*/_jsx(AnimatedList, {
    items: items
  });
}